import backend from '@common/backend';

const BASE = '/scheduleSettings';

export type RemoveScheduleLessonType = {
	is_according: number;
	transfer_gradebooks_to?: string;
	transfer_gradebooks?: boolean;
};

export const getScheduleSettings = async (scheduleId: number) =>
	backend.get(`${BASE}/${scheduleId}`);

export const createScheduleSettings = async (data: any) => backend.post(`${BASE}`, data);

export const createScheduleSettingsLyceum = async (data: any) =>
	backend.post(`${BASE}/lyceum`, data);

export const updateScheduleSettings = async (data: any) => backend.put(`${BASE}`, data);

export const updateLyceumScheduleSettings = async (data: any) =>
	backend.put(`${BASE}/lyceum`, data);

export const transferScheduleLesson = async (scheduleLessonId: number, data: any) =>
	backend.put(`${BASE}/${scheduleLessonId}`, data);

export const removeScheduleSettings = async (data: any) => backend.delete(`${BASE}`, data);

export const removeScheduleSettingsLyceum = async (data: any) =>
	backend.delete(`${BASE}/lyceum`, data);

export const removeScheduleLesson = async (
	scheduleLessonId: number,
	data: RemoveScheduleLessonType,
) => backend.delete(`${BASE}/scheduleLesson/${scheduleLessonId}`, data);

export const bulkRemoveScheduleLessons = async (data?: any) =>
	backend.delete(`${BASE}/scheduleLesson`, data);

export const addScheduleHolidays = async (data?: any) =>
	backend.post(`${BASE}/holidays`, data);
